import { ElementHelpers } from '../helpers/element-helpers';
import { Templates } from '../helpers/templates';

const template = `{{#options}}
	<li class="input-combobox__list--item {{#selected}}selected{{/selected}} {{#disabled}}disabled{{/disabled}}" data-value="{{value}}">
		{{label}}
	</li>
{{/options}}`;

export class ComboBox {

	constructor(elem) {
		this.elem = elem;
		this.selectElem = this.elem.querySelector('select');

		this.list = this.elem.querySelector('[data-select-list]');

		this.generateDropdown();

		this.listItems = this.list.querySelectorAll('li');

		this.addEventHandlers();
	}

	static getSelector() {
		return '.input-combobox';
	}

	/**
	 * The select element cannot be styled, therefore we created a shadow element.
	 */
	generateDropdown() {
		let options = this.selectElem.querySelectorAll('option'),
			dropdownItems = {options: []};

		for (let i = 0; i < options.length; i = i + 1) {
			let item = {
				value: options[i].value,
				label: options[i].innerText
			};

			item.selected = options[i].selected;
			item.disabled = options[i].disabled;

			dropdownItems.options.push(item);
		}

		// @TODO: this can be replaced with Templates.appendTemplate()
		Templates.renderTemplate(template, this.list, dropdownItems);
	}

	addEventHandlers() {
		this.selectElem.addEventListener('mousedown', (e) => {
			e.preventDefault();
			this.toggleList();
		});

		ElementHelpers.addEventListeners(this.listItems, 'click', (e) => {
			this.selectOption(e.currentTarget);
		});

		document.addEventListener('click', (e) => {
			if (this.elem.classList.contains('visible')) {
				if (e.target !== this.selectElem) {
					this.hideList(false);
				}
			}
		});
	}

	selectOption(option) {

		if(this.isDisabled(option)) {
			return false;
		}

		this.deselectOption();

		option.classList.add('selected');
		this.selectElem.value = option.dataset.value;
		ElementHelpers.triggerEvent(this.selectElem, 'change');

		this.toggleList();
	}

	deselectOption() {
		for (let i = 0; i < this.listItems.length; i++) {
			this.listItems[i].classList.remove('selected');
		}
	}

	toggleList(forced = undefined) {
		if (forced !== undefined) {
			this.elem.classList.toggle('visible', forced);
		} else {
			this.elem.classList.toggle('visible');
		}
	}

	hideList() {
		this.elem.classList.remove('visible');
	}

	isDisabled(option) {
		const value = option.dataset.value;
		const optionElement = this.selectElem.querySelector(`option[value="${value}"]`);
		return optionElement.disabled;
	}

}

